import eBillHomeApi from '@/api/eBillHome/eBillHomeApi.js';

export default {
	name: 'e-bill-change-sms2',
	mixins: [],
	extends: {},
	components: {},
	props: ['applyOption', 'applyText','notifyMdn', 'email', 'ebType'],
	data() {
		return {
			profile: this.$store.state.profile,
		};
	},
	computed: {

	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {

		init(){
			if(!this.ebType || (!this.email && !this.notifyMdn)){
				this.$router.push({name: 'e-bill-change-sms'});
			}
		},
		async ebillChangeConfirm(){
			let result = await eBillHomeApi.changeEBillType(this.profile.mdn, this.ebType, this.email, this.notifyMdn);
			
			if(result){
				this.$router.push({ name: 'e-bill-change-sms-result'});
				return;
			}

		}
	},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillChangeSMS/eBillChangeSMS2.js